<h1 mat-dialog-title> Valida Postulación Escolaridad </h1> <br/>

<mat-dialog-content>

    <p>
        <mat-form-field appearance="outline" class="mat-input">

            <mat-label> Beneficiario </mat-label>

            <mat-select *ngIf="data.carga" [(ngModel)]="data.beneficiario" [disabled]="data.deshabilitado" required>

                <mat-option *ngFor="let postulante of data.postulantes" value="{{postulante.id}}">

                    {{postulante.rut}} - {{postulante.dv}} {{postulante.nombres}} {{postulante.apellidoPaterno}}

                </mat-option>

            </mat-select>

            <input *ngIf="!data.carga" matInput [disabled]="true" [value]="data.beneficiario" />

        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance="outline" class="mat-input">

            <mat-label> Etapa Escolar </mat-label>

            <mat-select [(ngModel)]="data.etapaEscolar" [disabled]="data.deshabilitado" required>

                <mat-option *ngFor="let curso of data.cursos" value="{{curso}}"> {{curso}} </mat-option>

            </mat-select>

        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance="outline" class="mat-input">

            <mat-label> Fecha Certificado </mat-label>

            <input matInput type="date" placeholder="Fecha Certificado" [(ngModel)]="data.fechaCertificado" [disabled]="data.deshabilitado" required>

        </mat-form-field>
    </p>

    <p>
        <button class="btn-info mat-raised-button" (click)="onDescargarArchivosClick(data.idPostulacion)">

        <i class = "fa fa-download"> </i> Descargar Archivos Ingresado </button>
    </p>

</mat-dialog-content> <br/>

<mat-dialog-actions>
    <div *ngIf="data.rol != 'ROLE_EJECUTIVO_CAIP';  else roleReadOnly">
        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button class="mat-raised-button btn-warning" (click)="onEditarClick()">
            <i class ="fa fa-pen"> </i> Editar
        </button>

        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.mostrarAprobarButton" mat-button class="mat-raised-button btn-success" (click)="onAprobarClick(data.carga ? data.beneficiario : null,!data.carga ? data.beneficiario : null)">
            <i class = "fa fa-check"> </i> Aprobar
        </button>

        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button class="mat-raised-button btn-danger" (click)="onRechazarClick()">
            <i class = "fa fa-times"> </i> Rechazar
        </button>

        <button *ngIf="data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button class="mat-raised-button btn-success" (click)="onGuardarClick(data.carga ? data.beneficiario : null,!data.carga ? data.beneficiario : null)">
            <i class = "fa fa-download"> </i> Guardar
        </button>
        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </div>

    <ng-template #roleReadOnly>
        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </ng-template>

</mat-dialog-actions>